import React from 'react';
import Products from '../components/Products/Products';
import WhatsAppButton from '../components/WhatsAppButton/WhatsAppButton';
import './ProductsPage.css';

/**
 * Page Nos Produits - Solutions editees par WOTE
 */
function ProductsPage() {
  return (
    <div className="products-page">
      <div className="products-page-header">
        <div className="container">
          <div
            className="page-header-banner"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/female2.png)`,
            }}
          >
            <h1 className="page-title">Nos Produits</h1>
            <p className="page-subtitle">
              Des solutions WOTE conçues pour simplifier le quotidien et répondre à des besoins concrets
            </p>
          </div>
        </div>
      </div>

      <Products />

      <section className="products-page-cta">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Une idée de produit ou un besoin spécifique ?</h2>
            <p className="cta-description">
              Discutons de votre projet ou découvrez comment nous pouvons vous accompagner
            </p>
            <WhatsAppButton />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ProductsPage;
